///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>
///<reference path="../collections/report-employee-categories.collection.ts"/>
///<reference path="../collections/report-employees.collection.ts"/>
///<reference path="../collection-population-strategies/employee-to-categories.strategy.ts"/>
///<reference path="report-employee-secure.ts"/>
///<reference path="../validation/reqired-if-all-unselected.validation.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;
    

    export class ReportStudentWithCategoriesDataTemplate extends ReportEmployeeWitchCategoriesDataTemplate implements ISecureDataTemplate {
        /**
         *
         * @param model
         * @param properties - [categoryIds, employeeIds]
         * @param options
         */
        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, [properties[1]], options);
            this.title = 'LABEL_STUDENT';
            this.allSelectedLabel = 'LABEL_ALL_STUDENTS_UPPER'; 
            this.totalSelectedMessage = 'LABEL_TOTAL_STUDENTS_SELECTED';

        }

    }
}
